import React from 'react';
import { useDispatch } from 'react-redux';
import { MdArrowBackIos } from 'react-icons/md';
import { setSelectedLinkId } from 'store/graph/actions';
import {
  RELATIONSHIP_TYPE_CHARITABLE,
  RELATIONSHIP_TYPE_EDUCATION,
  RELATIONSHIP_TYPE_ENGAGEMENT,
  RELATIONSHIP_TYPE_FAMILY,
  RELATIONSHIP_TYPE_ORGANIZATIONAL,
  RELATIONSHIP_TYPE_PERSONAL,
  RELATIONSHIP_TYPE_ATTENDED,
  RELATIONSHIP_TYPE_FILTER_MATCH,
} from 'store/graph/constants';
import Charitable from './charitable';
import Family from './family';
import Personal from './personal';
import RelationshipHeader from './relationship-header';
import styles from './styles/relationshipCard.module.css';
import Organizational from './organizational';
import Education from './education';
import Engagement from './engagement';
import Attended from './attended';
import {
  CharitableIcon,
  EducationIcon,
  EngagementIcon,
  EventIcon,
  FamilyIcon,
  PersonalIcon,
  ProfessionalIcon,
} from 'common/icon/icon';
import FilterMatch from './filter-match';

const Relationship = ({ selectedEdge }) => {
  const dispatch = useDispatch();
  const { data, topNode, bottomNode } = selectedEdge;
  const goBack = () => {
    dispatch(setSelectedLinkId(undefined));
  };

  const {
    connectionType,
    topNodeRelationshipType,
    bottomNodeRelationshipType,
  } = data;
  let icon = <></>;
  let nodes = <></>;
  if (connectionType === RELATIONSHIP_TYPE_FAMILY) {
    icon = <FamilyIcon className={styles.family_icon} />;
    nodes = (
      <Family
        topNode={topNode}
        bottomNode={bottomNode}
        data={data}
        topRelation={topNodeRelationshipType}
        bottomRelation={bottomNodeRelationshipType}
      />
    );
  } else if (connectionType === RELATIONSHIP_TYPE_PERSONAL) {
    icon = <PersonalIcon className={styles.professional_icon} />;
    nodes = (
      <Personal
        topNode={topNode}
        bottomNode={bottomNode}
        data={data}
        topRelation={topNodeRelationshipType}
        bottomRelation={bottomNodeRelationshipType}
      />
    );
  } else if (connectionType === RELATIONSHIP_TYPE_CHARITABLE) {
    icon = <CharitableIcon className={styles.charitable_icon} />;
    nodes = (
      <Charitable
        topNode={topNode}
        bottomNode={bottomNode}
        data={data}
        topRelation={topNodeRelationshipType}
        bottomRelation={bottomNodeRelationshipType}
      />
    );
  } else if (connectionType === RELATIONSHIP_TYPE_ORGANIZATIONAL) {
    icon = <ProfessionalIcon className={styles.organization_icon} />;
    nodes = (
      <Organizational
        topNode={topNode}
        bottomNode={bottomNode}
        data={data}
        topRelation={topNodeRelationshipType}
        bottomRelation={bottomNodeRelationshipType}
      />
    );
  } else if (connectionType === RELATIONSHIP_TYPE_EDUCATION) {
    icon = <EducationIcon className={styles.education_icon} />;
    nodes = (
      <Education
        topNode={topNode}
        bottomNode={bottomNode}
        topRelation={topNodeRelationshipType}
        bottomRelation={bottomNodeRelationshipType}
      />
    );
  } else if (connectionType === RELATIONSHIP_TYPE_ENGAGEMENT) {
    icon = <EngagementIcon />;
    nodes = (
      <Engagement
        topNode={topNode}
        bottomNode={bottomNode}
        topRelation={topNodeRelationshipType}
        bottomRelation={bottomNodeRelationshipType}
      />
    );
  } else if (connectionType === RELATIONSHIP_TYPE_ATTENDED) {
    icon = <EventIcon className={styles.event_icon} />;
    nodes = (
      <Attended
        topNode={topNode}
        bottomNode={bottomNode}
        data={data}
        topRelation={topNodeRelationshipType}
        bottomRelation={bottomNodeRelationshipType}
      />
    );
  } else if (connectionType === RELATIONSHIP_TYPE_FILTER_MATCH || data?.connection === 'filter_match') {
    // Filter match edges get a custom panel without the standard relationship header
    return (
      <div className={styles.card}>
        <div className={styles.filter_match_header}>
          <div className={styles.filter_match_back} onClick={goBack}>
            <MdArrowBackIos style={{ color: '#38b2d9', fontSize: '14px' }} />
            <span style={{ color: '#fff', fontWeight: 700 }}>Back</span>
          </div>
        </div>
        <div className={styles.content}>
          <FilterMatch topNode={topNode} bottomNode={bottomNode} />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.card}>
      <RelationshipHeader goBack={goBack} icon={icon} properties={data} />
      <div className={styles.content}>{nodes}</div>
    </div>
  );
};

export default Relationship;
